module.exports = __webpack_public_path__ + "img/fail.2f48db78.png";